<template>
  <div class="overflow-hidden leading-5 my-3">
    <div v-for="file in files" :key="file.filename" class="mb-4">
      <div v-if="file.key" class="flex items-center">
        <img src="/images/file-img.svg" alt="image" width="16" height="16" class="float-left mr-3" loading="lazy" />
        <a :href="getImageUrl(file.key, file.filename)" target="_blank">
          <InlineHtml v-if="file.title" :text="file.title"></InlineHtml>
        </a>
      </div>
      <div v-else-if="file.folder" class="flex items-center">
        <img src="/images/file-pdf.svg" alt="pdf" width="16" height="16" class="float-left mr-3" loading="lazy" />
        <a :href="getFileUrl(file.folder, file.filename)" target="_blank">
          <InlineHtml v-if="file.title" :text="file.title"></InlineHtml>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { getImageUrl } = useUrls()
const { files } = defineProps<{ files: TabContent['files'] }>()
</script>
